:host {
  display: none;
  width: 100%;
  height: 100%;
  background-color: var(--white-layout-302-level-1-elevation);
}

:host([data-is-visible]) {
  display: block;
}

.form-section {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  align-items: flex-start;
  flex-direction: column;

  #form-title {
    margin-bottom: 16px;
  }
}
